import React, { useEffect, useState } from 'react'
import { Col } from 'react-bootstrap';
import BasicSpinner from '../../../../components/Spinner/BasicSpinner';
import { GUEST_USER} from '../../../../constants';
import ActiveLocation from './ActiveLocation';
import InActiveLocation from './InActiveLocation';
import styleclasses from "../../../../../src/containers/order/order.module.scss"
import { useAuthState } from '../../../../context/UserAuthentication';
import useAddFavoriteLocation from '../../../../react-query-hooks/Favorites/useAddFavoriteLocation';
import useRemoveFavoriteLocation from '../../../../react-query-hooks/Favorites/useRemoveFavoriteLocation';
import {LocationModel} from "../../../../models/location.model";
import { Toast_Func } from '../../../../helpers/toast.helper';
import { isGuestUser } from '../../../../helpers/helperMethods';
interface ISearchedLocationsCardProps {
    styleClasses: { readonly [key: string]: string; }
    location: any;
    isDeviceIos: boolean;
    isLocationLoading: boolean;
    myRefs:any;
    hovered:number;
    handleSelectedLocation: (selectedLocation:LocationModel) => void;
    currentSelectedLocation:LocationModel;
    getInfo: (id) => void;
}

const SearchedLocationsCard: React.FC<ISearchedLocationsCardProps> = ({ styleClasses, location, isDeviceIos, isLocationLoading, myRefs, hovered, handleSelectedLocation, currentSelectedLocation, getInfo }) => {

    let { mutateAsync: removeFavorite } = useRemoveFavoriteLocation();
    let { mutateAsync: addFavorite } = useAddFavoriteLocation();

    const [favoriteLocations, setFavoriteLocations] = useState([]);
    const { authInfo } = useAuthState();
    const isGuest = isGuestUser(authInfo);

    const selectedLocation: any = JSON.parse(localStorage.getItem('SelectedLocation'))

    useEffect(() => {
        const favoriteLocations = [];
        location.map(currentLocation => {
            if (currentLocation.is_favorite){
                favoriteLocations.push(currentLocation?.id)
            };
        })
        setFavoriteLocations(favoriteLocations)
      }, [location]);

    const removeFavoriteItem = (favoriteItemId: any, item: any) => {
        const userId = authInfo.userId;
        try{
          removeFavorite(
            { locationId: favoriteItemId, userId },
            {
              onError: (error, variables, context) => {
                setFavoriteLocations([...favoriteLocations, { ...item, item_id: item.id }]);
              },
            }
          );
        } catch(error){
          console.error('Unhandled add favorite error:', error);
        }
      };

      const addFavoriteLocation = async (location: any) => {
        try {
          await addFavorite(
            {customer_id: authInfo.userId, location_id:location?.id, isGuest },
            {
              onError: (error: any, variables, context) => {
                console.error('Add favorite location error:', error);
                
                // Revert the optimistic update - remove the location that was just added
                setFavoriteLocations(prevFavorites => 
                  prevFavorites.filter(fav => fav !== location?.id)
                );

                // Handle specific error cases
                if (error?.response?.status === 400) {
                  const errorMessage = error?.response?.data?.errors?.message || 'Unable to add favorite location. You may have reached the maximum limit.';
                  Toast_Func({ status: false, message: errorMessage });
                } else {
                  Toast_Func({ status: false, message: 'Something went wrong. Please try again.' });
                }
              },
            }
          );
        } catch (error) {
          // Additional catch to prevent React error overlay
          console.error('Unhandled add favorite error:', error);
        }
      };
    
      const favoriteButtonHandler = async (
        e: React.MouseEvent<HTMLButtonElement>,
        location
      ) => {
          e.stopPropagation();
          try{
              const favoriteLocationId = favoriteLocations.findIndex(
                  (fav) => fav === location?.id
              );
              const favoritesCopy = [...favoriteLocations];
              const locationId = location.id;
              if (favoriteLocationId === -1) {
                  favoritesCopy.push(location?.id);
                  setFavoriteLocations(favoritesCopy);
                  await addFavoriteLocation(location);
              } else {
                  favoritesCopy.splice(favoriteLocationId, 1);
                  setFavoriteLocations(favoritesCopy);
                  removeFavoriteItem(locationId, location);
              }
          }
          catch (error)
          {
              console.log('Error in favoriteButtonHandler:', error);
          }
      };

      const isThisActiveLocation = (location : LocationModel) => {
        if(currentSelectedLocation) {
          return location?.id === currentSelectedLocation?.id
        }else{
          return location?.id === selectedLocation?.id
        }
      }

    return (
        <Col md="12" lg="12" xxl="12" className={`${styleclasses.card_map_scroll_mobile_designv2} mb-2`} 
        id='scroll2' 
        data-testid="searched-location"
        >
            {isLocationLoading ? 
            <div><BasicSpinner BasicSpinner={"position-relative"} style={{left:'44%',top:'5%'}}/></div>
            :
            
                    [...location].sort((a, b) => {
                        const aIsActive = isThisActiveLocation(a);
                        const bIsActive = isThisActiveLocation(b);
                        if (aIsActive && !bIsActive) return -1;
                        if (!aIsActive && bIsActive) return 1;
                        return 0;
                    }).map(location => {
                    return <div 
                    ref={(el) => (myRefs.current[location.id] = el)}
                    key={location.id}
                    className={`pt-1`}
                    >
                        {
                            isThisActiveLocation(location) ? (
                                <ActiveLocation
                                    styleClasses={styleClasses}
                                    location={location}
                                    isDeviceIos={isDeviceIos}
                                    hovered={hovered}
                                    favoriteButtonHandler={favoriteButtonHandler}
                                    favoriteLocations={favoriteLocations}
                                    handleSelectedLocation={handleSelectedLocation}
                                    isGuest={isGuest}
                                    getInfo={getInfo}
                                />
                            ) : 
                                  <InActiveLocation
                                    styleClasses={styleClasses}
                                    location={location}
                                    isDeviceIos={isDeviceIos}
                                    hovered={hovered}
                                    favoriteButtonHandler={favoriteButtonHandler}
                                    favoriteLocations={favoriteLocations}
                                    handleSelectedLocation={handleSelectedLocation}
                                    isGuest={isGuest}
                                    getInfo={getInfo}
                                />
                        }
                    </div>
                })
            }
            
        </Col>
    )
}

export default SearchedLocationsCard
